import { Injectable, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductServiceModel, ProductServiceResponse} from './popup.model';
import { PopUpComponent } from '../popup.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../../../environments/environment';
import { ProductOverviewRequest } from '../../../../services/product-overview/product-overview-request.model';
import {Observable} from 'rxjs';

export interface PopUp {
  title: string;
  restrictedData: boolean;
  errorText: string;

  close();
  createErrorMessage(response);
  addValues(response);
}

export const baseUrl = environment.productViewDetailsBaseURL;

@Injectable({
  providedIn: 'root',
})
export class PopupService {

  public componentType;
  public requiredRequestData = {} as ProductServiceModel;

  constructor(private readonly http: HttpClient, public dialog: MatDialog) {
  }

  public openPopup(type: string, requiredRequestData: any): void {
    this.requiredRequestData = requiredRequestData;
    const popUpComponentType = {
      // tslint:disable-next-line:no-duplicate-string
      ProductService: {url: type, component: PopUpComponent },
    };

    this.componentType =  popUpComponentType['ProductService'];
    this.openProductServicePopUp(this.componentType.url, this.componentType.component);
  }

  public openProductServicePopUp(url: string, popupType: Type<PopUpComponent>): void {
    this.openCurrentPopup(url, popupType);
  }

  public getProductServices(url: string): Observable<ProductServiceResponse> {
    const productServiceUrl = baseUrl + url;
    const headers = this.createHeaders();

    const requestBody = {
      arrangementNumber: this.requiredRequestData.arrangementNumber,
      administrationCode: this.requiredRequestData.administrationCode,
      relationRestrictedDataView: this.requiredRequestData.relationRestrictedDataView,
      restrictedDataViewException: this.requiredRequestData.restrictedDataViewException,
      relationMarketSegmentCode: this.requiredRequestData.relationMarketSegmentCode,
      commercialProductTypeCode: this.requiredRequestData.commercialProductTypeCode,
      parametersToken: this.requiredRequestData.parametersToken,
      orgYN: this.requiredRequestData.orgYN,
    };

    return this.http.post<ProductServiceResponse>(productServiceUrl, requestBody, { headers });
  }

  public openCurrentPopup(url: string, popupComponentType: Type<PopUp>): void {
    this.getProductServices(url)
      .subscribe(
        (resp) => {
          this.openModal(resp, popupComponentType);
        }, (resp) => { this.openModal(resp, popupComponentType)});
  }

  private openModal(resp, popUpComponent: Type<PopUp>) {
    this.dialog.open(popUpComponent, {
      width: '400px',
      data: resp,
      panelClass: 'custom-modalbox',
    });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', ProductOverviewRequest.token);
    headers = headers.append('MFA-Authorization', ProductOverviewRequest.token);
    headers = headers.append('Graph-Authorization', ProductOverviewRequest.graphToken);
    headers = headers.append('Content-type', 'application/json');
    return headers;
  }

}
